import {
    InMemoryHeader,
    InMemoryString,
    InMemoryDate
  } from "pbas-vue-components";
  import { i18n } from '@/plugins/i18n';
  
  const InMemoryFileHeaders = [
    new InMemoryHeader({
      type: new InMemoryString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      version: 1
    }),
    new InMemoryHeader({
      title: "globals.name",
      type: new InMemoryString("FileName"),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new InMemoryHeader({
      title: "globals.date",
      type: new InMemoryDate("CreatedAt"),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new InMemoryHeader({
      title: "headers.inmemoryfiles.type_of_file",
      type: new InMemoryString("FileCategory", {
        getString: (item) => {
          const all = []
          for (const fileCategory of item.FileCategory) {
            all.push(i18n.t("enums." + fileCategory));
          }
          return all.join(", ");
        }
      }),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new InMemoryHeader({
      title: "components.employers.employer_details.notes",
      type: new InMemoryString("Notes"),
      sortable: true,
      visible: true,
      searchable: true
    }),
   
  ];
  export default InMemoryFileHeaders;